import React from 'react';
import ImageWrapper from '../../Global/Image/ImageWrapper';
import Link from '../../Global/Link/Link';

import './styles.scss';

const BlockMembers = ({ block }) => {
  const { items } = block;

  const renderMember = (member) => {
    const { fullname, gender, role, image, regions } = member;

    return (
      <article className="member-item">
        <ImageWrapper image={image} />

        <div className="metadata">
          <h3>{fullname}</h3>
          <div className="gender">{gender}</div>
          <div className="role">{role}</div>
          <div className="regions">
            {regions.map((r, index) => (
              <span key={index}>
                {r.label}
                {index !== regions.length - 1 ? ', ' : ''}
              </span>
            ))}
          </div>
        </div>
      </article>
    );
  };

  return (
    <div id="block-members">
      <div className="items">
        {items.map((item) => {
          const { id, withDetailPage } = item;

          if (!withDetailPage) {
            return <React.Fragment key={id}>{renderMember(item)}</React.Fragment>;
          }

          return (
            <Link key={id} to={item}>
              {renderMember(item)}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default BlockMembers;
